Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-wishlist-navigation');

    if ($wrapper.length < 1)
        return;

    var model = null;
    $.each($wrapper, function (i, wrapper) {
        wrapper.update = function () {
            var html = Vendd.Handlebars.parse("wishlistNavigation_A", model);
            wrapper.bind(html);
        };

        wrapper.bind = function bind(html) {
            $wrapper.html(html);
        };

        Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, wrapper, function (envelope) {
            model = envelope.message.data;
            wrapper.update();
        });
    });

    $wrapper.on('click', '.js-move-all-to-cart', function (e) {
        Vendd.MessageBus.publishAsync(e.delegateTarger, new Vendd.Wishlist.Messages.MoveAllToCart());
    });

});